import { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import '../Orders.css'
import { Pagination } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { getInvestmentList } from "../../../Services/investmentService";
import { StyledTableCell, StyledTableRow } from "../../common/commonTableStyles";
import NOT from "../../../Images/nodata.webp";
import SkeletonTable from "../../Skeleton/TableSkeleton";
import NoDataFound from "../../NoDataFound/NoDataFound";

function InvestmentHistory() {

    const [searchParams, setSearchParams] = useSearchParams();
    const [currentPage, setCurrentPage] = useState(searchParams.get("page") || 1);
    const [limit, setLimit] = useState(searchParams.get("limit") || 10);
    const [investmentData, setInvestmentData] = useState({ data: [], totalPages: 0, currentPage: 1 });
    const [investmentLoading, setInvestmentLoading] = useState(true);


    const fetchInvestmentList = async (payload) => {
        setInvestmentLoading(true);
        try {
            const { data } = await getInvestmentList(payload);
            if (data?.success) {
                setInvestmentData(data.result);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setInvestmentLoading(false);
        }
    };

    useEffect(() => {
        fetchInvestmentList({ page: currentPage, limit, filter: { status: 'closed' } });
    }, [searchParams]);

    const handlePageChange = (event, value) => {
        if (currentPage !== value) {
            setCurrentPage(value);
            if (value === 1) {
                setSearchParams({})
            } else {
                setSearchParams({ page: value })
            }
        };
    }

    return (
        <Grid2 container spacing={2} className="mt-20">
            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TableContainer sx={{ maxHeight: 600, scrollbarWidth: 'none', borderRadius: '12px 12px 12px 12px' }} className="mt-20">
                    {investmentLoading ? <SkeletonTable /> :
                        <Table sx={{ minWidth: 400, background: "var(--color-BasicBg)" }} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No</TableCell>
                                    <TableCell>Investment ID</TableCell>
                                    <TableCell>Invested Date</TableCell>
                                    <TableCell>Closed Date</TableCell>
                                    <TableCell>Pair</TableCell>
                                    <TableCell>Buy Price</TableCell>
                                    <TableCell>Sell Price</TableCell>
                                    <TableCell>Qty</TableCell>
                                    <TableCell>PNL</TableCell>
                                    <TableCell>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {investmentData?.data?.length > 0 ? investmentData?.data?.map((row, index) => (
                                    <StyledTableRow key={index}>
                                        <StyledTableCell>{(currentPage - 1) * limit + index + 1}</StyledTableCell>
                                        <StyledTableCell>{row?.investmentId || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.started_at || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.ended_at || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.pair || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.entryPrice || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.exitPrice || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.qty || "-"}</StyledTableCell>
                                        <StyledTableCell>{row?.pnl ? <span className={row?.pnl > 0 ? "green" : "red"}>{row?.pnl}</span> : "-"}</StyledTableCell>
                                        <StyledTableCell className="capitalize" >{row?.status || "-"}</StyledTableCell>
                                    </StyledTableRow>
                                )) : (
                                    <TableRow>
                                        <TableCell colSpan={9} align="center">
                                            <NoDataFound message="No closed investment record found" />
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    }
                </TableContainer>
                {!investmentLoading && investmentData?.data?.length > 0 && investmentData?.totalPages > 1 && (
                    <div className="Pagination-main">
                        <Pagination page={currentPage} count={investmentData?.totalPages} onChange={handlePageChange} />
                    </div>
                )}
            </Grid2>
        </Grid2>
    );
}

export default InvestmentHistory;
